import { render } from "./Clarifications.vue?vue&type=template&id=841d3bde&scoped=true"
import script from "./Clarifications.vue?vue&type=script&lang=js"
export * from "./Clarifications.vue?vue&type=script&lang=js"

import "./Clarifications.vue?vue&type=style&index=0&id=841d3bde&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-841d3bde"]])

export default __exports__